import { CONSTRUCTION_METHOD } from '@/constants/accessor/api/emergencyInspectionResult/buildingOverview/constructionMethod'
import { CONSTRUCTION_METHOD_MIXED } from '@/constants/accessor/api/emergencyInspectionResult/buildingOverview/constructionMethodMixed'
import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'

/** 構造形式 */
export const constructionMethodOption = {
  [CONSTRUCTION_TYPE.WOOD]: [
    { value: CONSTRUCTION_METHOD.WOOD.UNSELECTED, text: '未選択' },
    { value: CONSTRUCTION_METHOD.WOOD.WOODEN, text: '在来（軸組）構法' },
    { value: CONSTRUCTION_METHOD.WOOD.WALL, text: '枠組（壁）工法' },
    { value: CONSTRUCTION_METHOD.WOOD.PREFAB, text: 'プレファブ' },
    { value: CONSTRUCTION_METHOD.WOOD.OTHER, text: 'その他' }
  ],

  [CONSTRUCTION_TYPE.STEEL]: [
    { value: CONSTRUCTION_METHOD.STEEL.UNSELECTED, text: '未選択' },
    { value: CONSTRUCTION_METHOD.STEEL.RAMEN, text: 'ラーメン構造' },
    { value: CONSTRUCTION_METHOD.STEEL.BRACE, text: 'ブレース構造' },
    { value: CONSTRUCTION_METHOD.STEEL.PREFAB, text: 'プレファブ' },
    { value: CONSTRUCTION_METHOD.STEEL.OTHER, text: 'その他' }
  ],

  [CONSTRUCTION_TYPE.RC]: [
    { value: CONSTRUCTION_METHOD.RC.UNSELECTED, text: '未選択' },
    { value: CONSTRUCTION_METHOD.RC.REINFORCED, text: '鉄筋コンクリート造' },
    { value: CONSTRUCTION_METHOD.RC.PRECAST, text: 'プレキャストコンクリート造' },
    { value: CONSTRUCTION_METHOD.RC.BLOCK, text: 'ブロック造' },
    { value: CONSTRUCTION_METHOD.RC.STEEL_REINFORCED, text: '鉄骨鉄筋コンクリート造' },
    { value: CONSTRUCTION_METHOD.RC.MIXED, text: '混合構造' }
  ]
} as const

/** 構造形式混合構造 */
export const mixedOption = [
  { value: CONSTRUCTION_METHOD_MIXED.UNSELECTED, text: '未選択' },
  { value: CONSTRUCTION_METHOD_MIXED.REINFORCED, text: '鉄筋コンクリート造' },
  { value: CONSTRUCTION_METHOD_MIXED.PRECAST, text: 'プレキャストコンクリート造' },
  { value: CONSTRUCTION_METHOD_MIXED.BLOCK, text: 'ブロック造' },
  { value: CONSTRUCTION_METHOD_MIXED.STEEL_REINFORCED, text: '鉄骨鉄筋コンクリート造' }
]

export const OTHER_LABEL = 'その他'
